import { useContext } from 'react';

function useNonNullishContext(context) {
    const value = useContext(context);
    if (value === null || value === undefined) {
        throw new Error(`Context:${context.displayName} is null Or undefined`);
    }
    return value;
}

export { useNonNullishContext };
